<div class="container-fluid">
    <div class="row">
        <div class="page-title">
            <h3>{{ titleKey | translate }}</h3>
        </div>
    </div>
    <div class="row">
        <div class="col-md-9">
            <div *ngIf="loading" class="text-center py-5">
                <div class="spinner-border text-success" role="status">
                    <span class="visually-hidden">{{ 'common.loading' | translate }}...</span>
                </div>
            </div>

            <div *ngIf="!loading && requests?.length === 0" class="text-center py-5">
                <i class="fa fa-truck fa-3x text-muted mb-3"></i>
                <p class="text-muted">{{ 'delivery_requests.no_requests' | translate }}</p>
            </div>

            <div *ngIf="!loading && requests?.length > 0">
                <div class="request-row" *ngFor="let req of requests">
                    <div class="request-card">
                        <div class="request-card-body">
                            <div class="request-image" *ngIf="productPictureUrl(req)">
                                <img [src]="productPictureUrl(req)" [alt]="getProductName(req)">
                            </div>
                            <div class="request-image" *ngIf="!productPictureUrl(req)">
                                <div class="no-image">
                                    <i class="fa fa-image fa-2x text-muted"></i>
                                </div>
                            </div>
                            <div class="request-info">
                                <h5 class="request-product-name">{{ getProductName(req) }}</h5>
                                <div class="request-meta">
                                    <span class="meta-badge">Qty: {{ req.product?.qty }}</span>
                                    <span [class]="getStatusClass(req.deliveryStatus)">{{ getDeliveryStatusLabel(req.deliveryStatus) | translate }}</span>
                                </div>
                                <div class="request-seller">
                                    <span class="text-muted">{{ 'common.seller' | translate }}:</span>
                                    {{ req.seller?.firstName }} {{ req.seller?.lastName }}
                                </div>
                                <div class="request-addresses">
                                    <div class="address-line pickup" *ngIf="pickupAddressString(req)">
                                        <i class="fa fa-box me-1 text-muted"></i>
                                        <span class="address-label">{{ 'delivery_requests.pickup_address' | translate }}:</span>
                                        {{ pickupAddressString(req) }}
                                    </div>
                                    <div class="address-line delivery" *ngIf="deliveryAddressString(req)">
                                        <i class="fa fa-map-marker-alt me-1 text-muted"></i>
                                        <span class="address-label">{{ 'delivery_requests.delivery_address' | translate }}:</span>
                                        {{ deliveryAddressString(req) }}
                                    </div>
                                </div>
                            </div>
                            <div class="request-price">
                                <div class="request-amount">{{ formatCurrency(req.deliveringAmount) }}</div>
                                <a (click)="viewDetail(req)" class="btn btn-success order-view-btn mt-2">
                                    {{ 'delivery_requests.view_details' | translate }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="!loading && config && config.totalOfPage > 1">
                <div class="col-12">
                    <div class="pager">
                        <pagination-controls class="pages"
                                             maxSize="5"
                                             [previousLabel]="'common.previous' | translate"
                                             [nextLabel]="'common.next' | translate"
                                             autoHide="true"
                                             id="delivery-listing"
                                             (pageChange)="pageChange($event)">
                        </pagination-controls>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <app-sidebar [currentUser]="user"></app-sidebar>
        </div>
    </div>
</div>